export {default} from 'views/Accounts/Accounts'



// WEBPACK FOOTER //
// ./src/views/Administration/Accounts.jsx